import { createApp } from "vue";
import Axios from "axios";
import AppConfig from "@Account/Scripts/Config/AppConfig";
import { router } from "@Account/Scripts/Config/RouteConfig";
import { store } from "@Account/Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["App", "Account", "CookieToast"]
        });

        this.initRequestVerificationToken();

        const app = createApp({});
        (<any>app).config.devtools = false;

        app.use(router).use(store).use(AppConfig);

        (<any>window).App.instances.vm = app.mount('#app');
    }

    private static initRequestVerificationToken() {
        var antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }
}